import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const MANUAL_QUESTIONS_REQUEST = 'MANUAL_QUESTIONS_REQUEST';
export const MANUAL_QUESTIONS_FETCH_SUCCESS = 'MANUAL_QUESTIONS_FETCH_SUCCESS';
export const MANUAL_QUESTIONS_SUBMIT_REQUEST = 'MANUAL_QUESTIONS_SUBMIT_REQUEST';
export const MANUAL_QUESTIONS_SUBMIT_SUCCESS = 'MANUAL_QUESTIONS_SUBMIT_SUCCESS';
export const MANUAL_QUESTIONS_FAILURE = 'MANUAL_QUESTIONS_FAILURE';

function request(formId) {
  return {
    type: MANUAL_QUESTIONS_REQUEST,
    formId
  };
}

function fetchSuccess(formId, manualQuestionsState) {
  return {
    type: MANUAL_QUESTIONS_FETCH_SUCCESS,
    formId,
    manualQuestionsState
  };
}

function submitRequest(formId) {
  return {
    type: MANUAL_QUESTIONS_SUBMIT_REQUEST,
    formId
  };
}

function submitSuccess(formId, manualQuestionsState, validationResult) {
  return {
    type: MANUAL_QUESTIONS_SUBMIT_SUCCESS,
    formId,
    manualQuestionsState,
    validationResult
  };
}

function reject(formId, manualQuestionsError) {
  return {
    type: MANUAL_QUESTIONS_FAILURE,
    formId,
    manualQuestionsError
  };
}

export function getManualQuestions(formId) {
  return (dispatch) => {
    dispatch(request(formId));

    const promise = () => ApiService
      .getManualQuestions(formId)
      .then((response) => {
        dispatch(fetchSuccess(formId, response.data));
      })
      .catch((error) => {
        dispatch(handleException(error, message => reject(formId, message), false));
      });
    return promise();
  };
}

export function submitManualQuestions(formId, answers) {
  return (dispatch) => {
    dispatch(submitRequest(formId));

    const promise = () => ApiService
      .submitManualQuestions(formId, { answers })
      .then((response) => {
        dispatch(submitSuccess(formId, response.data.state, response.data.validation));
        toastr.success('Success', 'Your manual validation answers have been saved.');
      })
      .catch((error) => {
        if (error.response && error.response.status === 409) {
          dispatch(getManualQuestions(formId));
        }
        dispatch(handleException(error, message => reject(formId, message), true));
      });
    return promise();
  };
}
